import React from 'react';

/**
 * Rundes Profilbild. Ohne hochgeladenes Bild die Initialen des Namens -
 * ein leerer grauer Kreis sagt nichts, Initialen unterscheiden die Karten
 * in der Crew-Liste auch dann, wenn noch niemand ein Bild hat.
 */
export function initialsOf(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Kantenlaenge je Groesse - muss zu den Regeln in App.css passen. */
const SIZE_PX = { sm: 38, md: 48, lg: 128 };

export default function MemberAvatar({ member, size = 'md' }) {
  const name = member?.displayName || 'Mitglied';
  const className = `mt-avatar mt-avatar--${size}`;
  const px = SIZE_PX[size] ?? SIZE_PX.md;

  if (member?.avatarUrl) {
    return (
      <img
        className={className}
        src={member.avatarUrl}
        alt={`Profilbild von ${name}`}
        loading="lazy"
        width={px}
        height={px}
      />
    );
  }

  // Die Initialen sind rein dekorativ - der Name steht immer daneben.
  return (
    <span className={className} aria-hidden="true">
      {initialsOf(name)}
    </span>
  );
}
